import service from '@/api';

/**
 * 맞품학습 오답노트 리스트 반환
 * @param {levelParamList:1,2, classList:Y1_01,Y1_02} params
 * @param {*} callback
 * @returns
 */
export const getWrongList = async (params, callback) => {
    const { data } = await service({
        url: '/api/my-note/normal-wrong-list',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
export const getWrongList2 = async (params) => {
    try {
        const res = await service({
            url: '/api/my-note/normal-wrong-list',
            method: 'get',
            params,
        });
        return res;
    } catch (e) {
        return null;
    }
};

/**
 * 마이노트 심화 리스트 반환
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const getKillerList = async (params, callback) => {
    const { data } = await service({
        url: '/api/my-note/normal-killer-list',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 마이노트 수능 리스트 반환
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const getSatList = async (params, callback) => {
    const { data } = await service({
        url: '/api/my-note/sat-wrong-list',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 마이노트 문제 리스트 반환
 * @param {examNameCsv: KRT_01_01_L_01,KRT_01_01_L_02} params
 * @param {*} callback
 * @returns
 */
export const getNoteProblemList = async (params, callback) => {
    const { data } = await service({
        url: '/api/my-note/wrong-answer-list',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 오답노트 맞춤학습 답변
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postKillerAnswer = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/my-note/killer-answer',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 오답노트 수능학습 답변
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postNoteAnswer = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/my-note/wrong-answer',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 오답노트 히스토리 조회
 * @param {*} params
 * @returns
 */
export const getWrongHistories = async (params) => {
    const { data } = await service({
        url: '/api/my-note/wrong/history/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return data.data;
    return null;
};

/**
 * 심화노트 히스토리 조회
 * @param {*} params
 * @returns
 */
export const getKillerHistories = async (params) => {
    const { data } = await service({
        url: '/api/my-note/killer/history/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return data.data;
    return null;
};

/**
 * 오답노트 문제풀이 조회
 * @param {*} params
 * @returns
 */
export const getWrongAnswerHistories = async (params) => {
    const { data } = await service({
        url: '/api/my-note/wrong/answer/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return data.data;
    return null;
};

/**
 * 심화노트 문제풀이 조회
 * @param {*} params
 * @returns
 */
export const getKillerAnswerHistories = async (params) => {
    const { data } = await service({
        url: '/api/my-note/killer/answer/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return data.data;
    return null;
};
